const PEP = {
  title: 'Parceiro Padrão Zé',
  scoreboard: {
    title: 'Placar da sua loja',
    updatedAt: 'Atualizado em',
    viewHistory: 'ver histórico',
    sealsTooltip:
      'Quantidade de selos conquistados. Definem o seu nível e sua posição no ranking.',
  },
  history: {
    title: 'Histórico de selos',
    legend: {
      operational: 'Performance Operacional - Semanal',
      club: 'Missões Clube Zé+ - Mensal',
      quality: 'Jeito Zé de Qualidade - Trimestral',
    },
    categories: {
      operational: 'Performance Operacional',
      club: 'Missões Clube Zé+',
      quality: 'Qualidade Zé',
    },
  },
}

export default PEP
